import { useEffect, useRef } from "react";
import { User, Bot } from "lucide-react";

function Avatar({ isUser }) {
  return (
    <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${isUser ? "bg-[#2F4F4F]/30" : "bg-[#007BFF]/20"}`}>
      {isUser ? <User className="w-3 h-3 text-ib-text-secondary" /> : <Bot className="w-3 h-3 text-[#007BFF]" />}
    </div>
  );
}

function Message({ msg }) {
  if (msg.role === "system") {
    return (
      <div className="text-center px-4 py-1.5">
        <span className="inline-block px-3 py-1 rounded-full bg-ib-lime/10 text-ib-lime font-jetbrains text-[10px]">{msg.content}</span>
      </div>
    );
  }
  const isUser = msg.role === "user";
  return (
    <div className={`flex items-start gap-2 ${isUser ? "flex-row-reverse" : ""}`}>
      <Avatar isUser={isUser} />
      <div className={`max-w-[78%] rounded-2xl px-3.5 py-2 ${isUser ? "bg-[#007BFF] text-white rounded-tr-sm" : "bg-ib-surface border border-[#2F4F4F]/15 text-ib-text rounded-tl-sm"}`}>
        <p className="font-manrope text-[13px] leading-relaxed whitespace-pre-wrap">{msg.content}</p>
      </div>
    </div>
  );
}

function TypingIndicator() {
  return (
    <div className="flex items-start gap-2">
      <Avatar isUser={false} />
      <div className="bg-ib-surface border border-[#2F4F4F]/15 rounded-2xl rounded-tl-sm px-4 py-3 flex items-center gap-1.5">
        {[0, 150, 300].map((d) => <span key={d} className="w-1.5 h-1.5 bg-[#007BFF] rounded-full animate-bounce" style={{ animationDelay: `${d}ms` }} />)}
      </div>
    </div>
  );
}

export function MessageList({ messages, loading }) {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);
  return (
    <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3" data-testid="chat-messages">
      {messages.map((msg, i) => <Message key={`${msg.role}-${i}`} msg={msg} />)}
      {loading && <TypingIndicator />}
      <div ref={endRef} />
    </div>
  );
}
